const language = {
  label: 'Select Language',
};

export default language;
